/**
 * UUID v4 compatible with browsers that lack crypto.randomUUID (older WebViews, iOS).
 */
export function randomUUID(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  const bytes = new Uint8Array(16);
  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
    crypto.getRandomValues(bytes);
  } else {
    // Last-resort fallback for environments without Web Crypto (non-security IDs).
    let seed = Date.now() ^ (typeof performance !== 'undefined' ? performance.now() : 0);
    for (let i = 0; i < bytes.length; i += 1) {
      seed = (Math.imul(1664525, seed) + 1013904223) >>> 0;
      bytes[i] = seed & 0xff;
    }
  }

  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
